__turbopack_context__.v({
  "button": "YaPaySplitButton-module-scss-module__oKSuWa__button",
  "inner": "YaPaySplitButton-module-scss-module__oKSuWa__inner",
  "loading": "YaPaySplitButton-module-scss-module__oKSuWa__loading",
});
